<template>
  <div>
    <div ref="social" class="social">
      <ul>
        <li>
          <Facebook/>
        </li>
        <li>
          <Twitter/>
        </li>
        <li>
          <Pinterest/>
        </li>
        <li>
          <Linkedin/>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import Facebook from "../../../components/icons/social/Facebook";
import Twitter from "../../../components/icons/social/Twitter";
import Pinterest from "../../../components/icons/social/Pinterest";
import Linkedin from "../../../components/icons/social/Linkedin";

export default {
  name: "SocialShares",
  components: {Linkedin, Pinterest, Twitter, Facebook},
  mounted() {
    let visible = false
    document.addEventListener('g2rScroll', function (event) {
      const social = document.querySelector('.social')
      if (!visible && event.detail > 400) {
        social.classList.add('visible');
        visible = true
      }
      // if (visible && event.detail < 400 ) {
      //   visible = false
      //   social.classList.remove('visible')
      // }
      // console.log(event.detail,visible)
    })
  },
}
</script>

<style scoped lang="scss">
.social {
  position: sticky;
  top: 30vh;
  float: left;
  opacity: 0;
  transition: opacity 1s;
  //margin-bottom: 85rem;

  &.visible {
    opacity: 1;
  }

  ul {
    li {
      opacity: .6;
      transition: opacity .3s;
      margin-bottom: 1rem;
      border: 1px solid;
      display: flex;
      border-radius: 5px;
      padding: 5px;
      cursor: pointer;

      &:hover {
        opacity: 1;
      }
    }
  }
}
</style>

<style lang="scss">
.content-sidebar-wrap {
  display: grid;
  grid-template-columns: 0 auto;
}
</style>
